// @core/api/endpoints/platform/revoke_data_consent.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RevokeDataConsentRequest,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Revoke data consent
 * Revokes previously granted consent for cross-border data sharing. Data that has already been shared is not affected, but no new data will be transferred.
 */
export async function RevokeDataConsent(
  consent_id: string,
  data: RevokeDataConsentRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/federation/consent/:consent_id/revoke`;
  requestPath = requestPath.replace(':consent_id', encodeURIComponent(consent_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
